import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import Enhancer from './GlobalComponentEnhancer'

import ChangelogModal from 'Components/ChangelogModal'
import ConfirmationModal from 'Components/ConfirmationModal'
import CreateGroupModal from 'Components/CreateGroupModal'
import CreateReservationModal from 'Components/CreateReservationModal'
import CreateUserModal from 'Components/CreateUserModal'
import EditReservationModal from 'Components/EditReservationModal'
import FeedbackModal from 'Components/FeedbackModal'
import GlobalMessage from 'Components/GlobalMessage'
import MyAccountModal from 'Components/MyAccountModal'
import SettingsModal from 'Components/SettingsModal'

import * as styles from './styles'

const GlobalComponent = props => {
  const { hideChangelogModal, hideErrorMessage, hideSuccessMessage, messages, modals } = props

  return (
    <div style={styles.container}>
      {messages.error.visible && (
        <GlobalMessage
          autoCloseAfter={3000}
          dismiss={hideErrorMessage}
          header="Something went wrong"
          icon="warning sign"
          message={messages.error.message}
          error
        />
      )}

      {messages.success.visible && (
        <GlobalMessage
          autoCloseAfter={3000}
          dismiss={hideSuccessMessage}
          header="Good News Everyone!"
          icon="check"
          message={messages.success.message}
          positive
        />
      )}

      {modals.confirmation.visible && <ConfirmationModal message={modals.confirmation.message} onAccept={modals.confirmation.onAccept} />}

      {modals.changelog.visible && <ChangelogModal close={hideChangelogModal} />}

      {modals.feedback.visible && <FeedbackModal />}

      {modals.groupCreate.visible && <CreateGroupModal />}

      {modals.myAccount.visible && <MyAccountModal />}

      {modals.reservationCreate.visible && <CreateReservationModal />}

      {modals.reservationEdit.visible && <EditReservationModal />}

      {modals.settings.visible && <SettingsModal />}

      {modals.userCreate.visible && <CreateUserModal />}
    </div>
  )
}

GlobalComponent.propTypes = {
  hideChangelogModal: PropTypes.func.isRequired,
  hideErrorMessage: PropTypes.func.isRequired,
  hideSuccessMessage: PropTypes.func.isRequired,
  modals: PropTypes.shape({
    changelog: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    confirmation: PropTypes.shape({
      message: PropTypes.string.isRequired,
      onAccept: PropTypes.object.isRequired,
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    feedback: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    groupCreate: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    myAccount: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    reservationCreate: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    reservationEdit: PropTypes.shape({
      reservation: PropTypes.object.isRequired,
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    settings: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    userCreate: PropTypes.shape({
      visible: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  messages: PropTypes.shape({
    error: PropTypes.shape({
      message: PropTypes.string.isRequired,
      visible: PropTypes.bool.isRequired,
    }).isRequired,
    success: PropTypes.shape({
      message: PropTypes.string.isRequired,
      visible: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
}

const composed = compose(Enhancer)

export default composed(GlobalComponent)
